export default function regleFacturationInitialize(dcf) {
  const ligne = dcf.lignesCommande.find((ligne) => {
    return ligne.produit
      && ligne.produit?.supportCommercial?.societeId === dcf.societeId
      && ligne.produit.regleFacturationId;
  });
  if (ligne) dcf.regleFacturationId = ligne.produit.regleFacturationId;
  else dcf.regleFacturationId = null;
}
